<template>
    <div class="dropdown-main-container">
        <p class="text">{{ title }}</p>
        <date-picker class="text-input" v-model="value1" format="DD MMMM" type="date" readonly :lang="lang[currentLang]"
            :placeholder="formatDate(createdDate)">
        </date-picker>
    </div>
</template>

<script>

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { onVibrate } from '../helpers/utils';
import language from '../libs/i18n/index';
import { mapMutations } from "vuex"

export default {
    name: "Date-input",
    components: {
        DatePicker,
    },
    props: {
        title: {
            type: String,
            require: true
        },
        placeholder: {
            type: String,
            require: true
        },
        value: {
            type: String,
            require: true
        }
    },
    data() {
        return {
            value1: '',
            createdDate: this.setTodayDate(),
            currentLang: 'en',
            textMounths: {
                uk: {
                    1: 'Січня',
                    2: 'Лютого',
                    3: 'Березня',
                    4: 'Квітня',
                    5: 'Травня',
                    6: 'Червня',
                    7: 'Липня',
                    8: 'Серпня',
                    9: 'Вересня',
                    10: 'Жовтня',
                    11: 'Листопада',
                    12: 'Грудня',
                },
                en: {
                    1: 'January',
                    2: 'February',
                    3: 'March',
                    4: 'April',
                    5: 'May',
                    6: 'June',
                    7: 'July',
                    8: 'August',
                    9: 'September',
                    10: 'October',
                    11: 'November',
                    12: 'December',
                },
                ru: {
                    1: 'Января',
                    2: 'Февраля',
                    3: 'Марта',
                    4: 'Апреля',
                    5: 'Мая',
                    6: 'Июня',
                    7: 'Июля',
                    8: 'Августа',
                    9: 'Сентября',
                    10: 'Октября',
                    11: 'Ноября',
                    12: 'Декабря',
                },
                es: {
                    1: 'Enero',
                    2: 'Febrero',
                    3: 'Marzo',
                    4: 'Abril',
                    5: 'Mayo',
                    6: 'Junio',
                    7: 'Julio',
                    8: 'Agosto',
                    9: 'Septiembre',
                    10: 'Octubre',
                    11: 'Noviembre',
                    12: 'Diciembre',
                }
            }, 
            lang: {
                uk: {
                formatLocale: {
                    months: ['Січня', 'Лютого', 'Березня', 'Квітня', 'Травня', 'Червня', 'Липня', 'Серпня', 'Вересня', 'Жовтня', 'Листопада', 'Грудня'],
                    monthsShort: ['Січ', 'Лют', 'Бер', 'Квіт', 'Трав', 'Чер', 'Лип', 'Серп', 'Вер', 'Жов', 'Лис', 'Гру'],
                    weekdays: ['Неділя', 'Понеділок', 'Вівторок', 'Середа', 'Четвер', 'П`ятниця', 'Субота'],
                    weekdaysShort: ['Нед', 'Пон', 'Вівт', 'Сер', 'Чет', 'П`ятн', 'Суб'],
                    weekdaysMin: ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
                    firstDayOfWeek: 1,
                },
            },
                en: {
                    formatLocale: {
                        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                        monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                        weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                        weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                        weekdaysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                        firstDayOfWeek: 1,
                    },
                },
                ru: {
                    formatLocale: {
                        months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
                        monthsShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
                        weekdays: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
                        weekdaysShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
                        weekdaysMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
                        firstDayOfWeek: 1,
                    },
                },
                es: {
                    formatLocale: {
                        months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                        monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                        weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
                        weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
                        weekdaysMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
                        firstDayOfWeek: 1,
                    },
                }
        },

        }
    },
    async mounted() {
        const inputElement = document.querySelector('.mx-input');
        inputElement.addEventListener('click', () => {
            onVibrate('click')
        })
        inputElement.setAttribute('readonly', 'true');
    },

    methods: {
        ...mapMutations(['saveCreatedInfo', 'setClearCreatedInfo']),
      setTodayDate() {
          return new Date().getFullYear() + '-'
            + ('0' + (new Date().getMonth() + 1)).slice(-2) + '-'
            + ('0' + new Date().getDate()).slice(-2)
      },
      formatDate(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const currentYear = new Date().getFullYear();
        const month = date.getMonth() + 1
        const day = date.getDate();

        if (year < currentYear) {
            return `${day} ${this.textMounths[language.locale][month]} ${year}`;
        } else {
            return `${day} ${this.textMounths[language.locale][month]}`;
        }
    }
    },
    computed: {
    getCurrentLang() {
      return this.$store.getters.getCurrentLang
    },
    typeOperations() {
      return this.$store.getters.typeOperations  
    },
    createdInfo() {
      return this.$store.getters.createdInfo
    },
    },
    watch: {
    value1(newVal, oldVal) {
        onVibrate('click')
        if (newVal) {
            this.createdDate = this.formatDate(newVal.getFullYear() + '-'
            + ('0' + (newVal.getMonth() + 1)).slice(-2) + '-'
            + ('0' + newVal.getDate()).slice(-2)) 
        } else {
            this.createdDate = this.setTodayDate()
        }
        this.saveCreatedInfo({
            ...this.createdInfo,
            date: this.createdDate
        })
        let val = oldVal
        val         
      },
    'createdInfo.date'(newVal, oldVal) { 
        if (!this.createdInfo.price &&
            !this.createdInfo.title &&
            !this.createdInfo.currency &&
            !this.createdInfo.types && 
            !this.createdInfo.categories &&
            !newVal) {
            console.log({ newVal })
            this.createdDate = this.setTodayDate()
            this.value1 = new Date()
            console.log(this.createdDate)
            console.log(this.value1)
        }
        let val = oldVal
        val  
    },
    typeOperations(newVal, oldVal) {
        this.currentLang = this.getCurrentLang?.value;
        let val = oldVal
        val         
    }
    }
}
</script>

<style scoped>
    .dropdown-main-container {
        margin-bottom: 8px;
        display: flex;
        flex-direction: column;
        width: fit-content;
        position: relative;
        width: 100%;
        cursor: pointer;
    }
    .dropdown-main-container .text {
        font-size: 12px;
        color: #4A89DC;
        font-weight: 700;
        position: relative;
        top: 5px;
        margin: 0 0 0 7px;
        padding: 0 3px;
        z-index: 1;
        line-height: 10px;
        background: #e8e8e8;
        width: fit-content;
    }
    .dropdown-main-container .text-input {
        font-size: 0.75rem;
        /* border: 1px rgba(0, 0, 0, 0.07) solid; */
        border-radius: 10px;
        background: #e8e8e8;
        height: 53px;
        width: 100%;
        outline: none;
        font-weight: 400;
        line-height: 1.5;
        font-size: 12px;
        font-family: "Source Sans 3", sans-serif;
        color: #212529;
    }

     .dropdown-main-container .text-input::placeholder {
        color: #555f69;
    }
    .dropdown-left-icon-price {
        position: absolute;
        bottom: 40px;
        width: 23px;
        height: 23px;
        left: 10px;
    }
    .dropdown-left-icon {
        position: absolute;
        bottom: 15px;
        width: 23px;
        height: 23px;
        left: 10px;
    }
</style>